import config from "environment";
import { getRequest, postRequest } from "./client";
import { apiSetUserShowBannerPayload } from "./UserService.types";
import { EmployeeProfile, HomeScreenResponse, User } from "winslow-core";

const { baseApi } = config;

// get one share
export async function apiVerifyAppConnected(
  userId: string,
  appId: string
): Promise<boolean | null> {
  const fetchURL = `${baseApi}/users/verify-app-connected/${userId}/${appId}`;
  return await getRequest(fetchURL, "API/apiVerifyAppConnected");
}

export async function apiSetUserShowBanner(
  payload: apiSetUserShowBannerPayload
): Promise<User | null> {
  const fetchURL = `${baseApi}/users/set-show-banner`;
  return await postRequest(fetchURL, payload, "API/apiSetUserShowBanner");
}

export async function apiGetHomeScreen(
  userId: string,
  workspaceId: string
): Promise<HomeScreenResponse> {
  const fetchURL = `${baseApi}/users/home-screen/${userId}/${workspaceId}`;
  return (await getRequest(
    fetchURL,
    "API/apiGetHomeScreen"
  )) as HomeScreenResponse;
}

export async function apiGetEmployeeProfile(employeeId: string) {
  const fetchURL = `${baseApi}/employees/${employeeId}`;
  return (await getRequest(
    fetchURL,
    "API/apiGetEmployeeProfile"
  )) as EmployeeProfile | null;
}

export async function apiGetEmployeeProfileFromEmail(
  workspaceId: string,
  email: string
) {
  const fetchURL = `${baseApi}/employees/${workspaceId}/email?email=${encodeURI(email)}`;
  return (await getRequest(
    fetchURL,
    "API/apiGetEmployeeProfileFromEmail"
  )) as EmployeeProfile | null;
}

export async function apiGetWorkspaceEmployees(workspaceId: string) {
  const fetchURL = `${baseApi}/employees/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetWorkspaceEmployees");
}
